
import { useState, useEffect, useCallback } from 'react';

export function useBreathingLogic() {
  const [breathingPhase, setBreathingPhase] = useState<'inhale' | 'hold' | 'exhale'>('inhale');
  const [secondsLeft, setSecondsLeft] = useState(4);
  const [cyclesCompleted, setCyclesCompleted] = useState(0);
  
  // Use callback to prevent unnecessary recreations of the interval function
  const updateBreathingState = useCallback(() => {
    setSecondsLeft(prev => {
      if (prev <= 1) {
        // Time to change phase
        if (breathingPhase === 'inhale') {
          setBreathingPhase('hold');
          return 4; // Hold for 4 seconds
        } else if (breathingPhase === 'hold') {
          setBreathingPhase('exhale');
          return 4; // Exhale for 4 seconds
        } else {
          setBreathingPhase('inhale');
          setCyclesCompleted(prev => prev + 1);
          return 4; // Inhale for 4 seconds
        }
      }
      return prev - 1;
    });
  }, [breathingPhase]);
  
  useEffect(() => {
    // Timer for phase changes
    const timer = setInterval(updateBreathingState, 1000);
    
    return () => clearInterval(timer);
  }, [updateBreathingState]);

  return {
    breathingPhase,
    secondsLeft,
    cyclesCompleted,
    setBreathingPhase,
    setSecondsLeft,
    setCyclesCompleted
  };
}
